import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import AUIIcon from '@ancert/aui-icon';

const InfoHeader = ({ items }) => {
  const itemRender = items?.map((item) => (
    <li key={item.icon} className="c-sii-info-header__item">
      <AUIIcon color="blue" icon={item.icon} />
      <span>{item.description}</span>
    </li>
  ));

  return <ul className="c-sii-info-header u-mt-16">{itemRender}</ul>;
};
InfoHeader.propTypes = {
  items: arrayOf(shape({ icon: string, description: string })),
};
InfoHeader.defaultProps = {
  items: [],
};

export default InfoHeader;
